var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-pop", {
    staticClass: "error",
    attrs: { opened: _vm.error.active, confirm: "MCOM-0000003" },
    on: {
      "update:opened": function($event) {
        return _vm.$set(_vm.error, "active", $event)
      },
      confirm: function($event) {
        _vm.error.errType == "crcValidErr" ? _vm.goToPage() : _vm.retry()
      }
    },
    nativeOn: {
      touchstart: function($event) {
        $event.stopPropagation()
        return (function() {})($event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _vm.error.errType == "crcValidErr"
              ? _c("div", [_vm._v(_vm._s(_vm.$t(_vm.error.errMsgI18n)))])
              : _c("div", [
                  _c("div", { staticClass: "error-code" }, [
                    _c("i", { staticClass: "icon icon-error" }),
                    _c("div", [
                      _c("span", [_vm._v("Error Code")]),
                      _c("strong", [_vm._v(_vm._s(_vm.error.errCode))])
                    ])
                  ]),
                  _vm.error.errCode == "B99Z0082"
                    ? _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.error.errMsg) }
                      })
                    : _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.error.errMsg) }
                      }),
                  _c("p", [
                    _vm._v(_vm._s(/*전화상담*/ _vm.$t("MCOM-0000031")))
                  ]),
                  _vm.operGroupCd == "VN2"
                    ? _c("div", { staticClass: "btn-area" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn lg inline",
                            on: {
                              click: function($event) {
                                _vm.$goToTel(_vm.$t("지점별콜번호_oghni"))
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "icon icon-call" }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("지점별전화번호_oghni")) + " "
                            )
                          ]
                        )
                      ])
                    : _c("div", { staticClass: "btn-area" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn lg inline",
                            on: {
                              click: function($event) {
                                _vm.$goToTel(
                                  _vm.$t("지점별콜번호_" + _vm.siteCode)
                                )
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "icon icon-call" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("지점별전화번호_" + _vm.siteCode)
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }